import apiClient from "../../../utils/lib/apiClient";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useSetRecoilState } from "recoil";
import { useCallback } from "react";
export const useGetDiaryList = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getDiaryListByWokerAndDay = useCallback(
    async (workerNo: string, workingDate: string) => {
      setLoadingAnimation(true);
      setLoadingText("取得中...");
      try {
        const res = await apiClient.get(
          `/rocketForge/posts/getDiaryByWorkerAndDay/${Number(
            workerNo
          )}/${workingDate}`
        );
        const data = res.data;
        return data;
      } catch (e) {
        window.alert("エラーが発生しました" + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText("");
      }
    },
    [loadingState, loadingText]
  );
  const getDiaryListByAllParams = useCallback(
    async (
      productNo: string,
      productBno: string,
      workerNoList: number[],
      workingDateFrom: string,
      workingDateTo: string,
      factoryIds: number[]
      // constructionId: number
    ) => {
      setLoadingAnimation(true);
      setLoadingText("取得中...");
      try {
        const res = await apiClient.get(
          "/rocketForge/posts/getDiaryByAllParameters",
          {
            params: {
              productNo,
              productBno,
              workerNoList: workerNoList.join(","), // 配列をカンマ区切りの文字列に変換
              factoryIds: factoryIds.join(","), // 配列をカンマ区切りの文字列に変換
              workingDateFrom,
              workingDateTo,
              // constructionId,
            },
          }
        );
        const data = res.data;
        return data;
      } catch (e) {
        window.alert("エラーが発生しました" + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText("");
      }
    },
    [loadingState, loadingText]
  );

  return { getDiaryListByWokerAndDay, getDiaryListByAllParams };
};
